import { Injectable, signal, computed } from '@angular/core';

/**
 * Carries the passenger's "Pagar con saldo" intent across pages.
 * Set on the my-qr page, consumed by the scanner page after check-in.
 */
@Injectable({ providedIn: 'root' })
export class PaymentIntentService {
  readonly enabled = signal(false);
  readonly amount  = signal<number>(0);

  /** True only when toggle is on AND amount > 0 */
  readonly isReady = computed(() => this.enabled() && this.amount() > 0);

  toggle(value: boolean) { this.enabled.set(value); }
  setAmount(value: number) { this.amount.set(value); }

  /** Call after consuming the intent (post-payment or on error). */
  reset() {
    this.enabled.set(false);
    this.amount.set(0);
  }
}
